export const uploadAvatarSX = {
    modal: {
        overflow: "hidden"
    },

    confirmButtonBox: {
        background: (theme) => theme.palette.primary.main,
        borderRadius: "50%",
        position: "absolute",
        bottom: "10px",
        right: "10px",
        padding: "3px",
        cursor: "pointer !important"
    },

    avatarWrapper: {
        position: "relative",
        top: 0,
        width: "200px",
        height: "200px"
    },

    skeleton: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "200px",
        height: "200px"
    },

    outerBox: {
        display: "flex",
        position: "relative",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    },

    editIconBox: {
        position: "absolute",
        bottom: 0,
        right: 0,
        color: "blue",
        bgcolor: "white",
        borderRadius: "50%",
        border: "1px solid grey",
        cursor: "pointer"
    },
}